"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const react_toastify_1 = require("react-toastify");
const useHoustonTheme_1 = tslib_1.__importDefault(require("@eduzz/houston-styles/useHoustonTheme"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
const ToastContainer = props => {
    var _a;
    const theme = (0, useHoustonTheme_1.default)();
    const styleContent = React.useMemo(() => {
        var _a, _b;
        return ({
            __html: `
        ${styles_1.default}

        .Toastify__toast {
          border-radius: 4px;
          margin-bottom: 16px;
          padding: 8px 16px;
        }

        .Toastify__toast-body {
          font-family: ${(_b = (_a = theme === null || theme === void 0 ? void 0 : theme.font) === null || _a === void 0 ? void 0 : _a.family) !== null && _b !== void 0 ? _b : 'Open Sans'};
          font-weight: 600;
          padding-right: 8px;
          line-height: 1.45;
        }

        .Toastify__close-button {
          align-self: center;
        }
      `
        });
    }, [(_a = theme === null || theme === void 0 ? void 0 : theme.font) === null || _a === void 0 ? void 0 : _a.family]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("style", { dangerouslySetInnerHTML: styleContent }), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, Object.assign({}, props, { transition: react_toastify_1.Slide, position: 'top-right', autoClose: 4000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, draggable: false, pauseOnFocusLoss: true, pauseOnHover: true, icon: false, limit: 4 }))] }));
};
exports.default = ToastContainer;
